import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { AssistantReference } from '@/lib/types';

export interface AssistantReply {
  conversationId: string;
  message: string;
  references: AssistantReference[];
}

export function useAssistantChat() {
  return useMutation({
    mutationFn: (data: { question: string; conversationId?: string }) =>
      api<AssistantReply>('/api/assistant/chat', { method: 'POST', body: data }),
  });
}

export function useConversations() {
  return useQuery({
    queryKey: ['assistant', 'conversations'],
    queryFn: () =>
      api<{ conversations: Array<{ id: string; titulo: string; updatedAt: number }> }>(
        '/api/assistant/conversations',
      ),
  });
}
